export default "__VITE_ASSET__DqHeul7v__"